import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { AudienceKey, MapFiltersService } from '../../services/map-filters.service';

interface AudienceToggle {
  key: AudienceKey;
  label: string;
}

@Component({
  selector: 'app-filter-drawer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './filter-drawer.component.html',
  styleUrl: './filter-drawer.component.css',
})
export class FilterDrawerComponent {
  readonly filters = inject(MapFiltersService);

  readonly audienceToggles: AudienceToggle[] = [
    { key: 'kid', label: 'Kid Friendly' },
    { key: 'baby', label: 'Baby Friendly' },
    { key: 'pet', label: 'Pet Friendly' },
    { key: 'wheelchair', label: 'Pristupačno' },
  ];

  // Collapsed by default - the user clicks a section header to reveal its list.
  readonly regionsOpen = signal(false);
  readonly categoriesOpen = signal(false);

  toggleRegionsOpen(): void {
    this.regionsOpen.update((v) => !v);
  }

  toggleCategoriesOpen(): void {
    this.categoriesOpen.update((v) => !v);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.filters.closeDrawer();
  }
}
